import React from 'react';

const BlackboxLogoSquare = () => {
  return (
    React.createElement('svg', {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20"   ,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",}
    
      , React.createElement('g', { 'clip-path': "url(#clip0_2735_11189)",}
        , React.createElement('path', {
          d: "M2.16699 5.72082L10.3525 0L18.538 5.74343V14.3586L10.3525 19.989L2.16699 14.336V5.72082Z"     ,
          fill: "#4C93FF",}
        )
        , React.createElement('path', {
          d: "M10.3525 15.4666L2.16699 9.70052V14.2907L10.3525 19.9889L18.538 14.2907V9.70052L10.3525 15.4666Z"     ,
          fill: "#0B6CFF",}
        )
        , React.createElement('path', {
          d: "M6.41797 8.66037L10.3524 6.06L14.2869 8.66037V14.5847L10.3524 17.5695L6.41797 14.5847V8.66037Z"     ,
          fill: "#004EC3",}
        )
        , React.createElement('path', {
          d: "M3.38818 5.90171L10.3527 1.19843L17.3171 5.90171L10.3527 10.8989L3.38818 5.90171Z"     ,
          fill: "url(#paint0_linear_2735_11189)",}
        )
        , React.createElement('path', {
          d: "M10.0584 11.7808L2.77734 6.67053V14.042L10.0584 18.7905V11.7808Z"   ,
          fill: "#07080A",}
        )
        , React.createElement('path', {
          d: "M10.6465 11.7808L17.9275 6.67053V14.042L10.6465 18.7905V11.7808Z"   ,
          fill: "#07080A",}
        )
      )
      , React.createElement('defs', null
        , React.createElement('linearGradient', {
          id: "paint0_linear_2735_11189",
          x1: "8.07596",
          y1: "2.97505",
          x2: "12.3195",
          y2: "8.43101",
          gradientUnits: "userSpaceOnUse",}
        
          , React.createElement('stop', { 'stop-color': "#07080A",} )
          , React.createElement('stop', { offset: "0.5104", 'stop-color': "#292F3C",} )
          , React.createElement('stop', { offset: "1", 'stop-color': "#07080A",} )
        )
        , React.createElement('clipPath', { id: "clip0_2735_11189",}
          , React.createElement('rect', {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(0.333496)",}
          )
        )
      )
    )
  );
};

export default BlackboxLogoSquare;
